import React from 'react'

import { ValidatorForm } from 'react-material-ui-form-validator';

import {
    Grid,
    makeStyles,
    Button
} from "@material-ui/core";
import SaveIcon from "@material-ui/icons/Save";

import { useForm } from '../../../../hooks/useForm'
import { formCud } from '../../data/values';
import { FormDatosCud } from './FormDatosCud';

const useStyles = makeStyles((theme) => ({
    button: {
        margin: 2,
        textAlign: 'right'
    },
    switchBase: {
        color: '#bdbdbd',
        '&$checked': {
            transform: 'translateX(16px)',
            color: '#4CAF50',
            '& + $track': {
                backgroundColor: '#3E8040',
                opacity: 1,
                border: 'none',
            },
        },
    },
    checked: {},
    track: {},
}));

export const FormCud = ({ handleSubmit, afiliado, formularioCud }) => {
    const classes = useStyles();
    const [
        formValues,
        handleInputChange, ,
        setearValor, , , , ,
        setearVariosValores
    ] = useForm(formularioCud ? {
        ...formularioCud,
        diagnosticos: formularioCud.diagnosticos.map(item => ({
            codCie10: item.codCie10,
            descripcion: item?.diagnostico?.descripcion || item?.descripcion,
            idTipoDiscapacidad: item.idTipoDiscapacidad,
            idFrecuenciaDiscapacidad: item.idFrecuenciaDiscapacidad,
            idAlcanceDiscapacidad: item.idAlcanceDiscapacidad
        }))
    } : formCud({ afiliado: afiliado }));

    const onSubmit = (e) => {
        e.preventDefault();
        handleSubmit({ ...formValues });
    };

    return (
        <Grid container justify="space-between" alignItems="center" spacing={1} style={{ padding: "0.2em 1em" }}>
            <ValidatorForm onSubmit={onSubmit}>
                <Grid container spacing={2} alignItems="center">
                    <FormDatosCud
                        formValues={formValues}
                        handleInputChange={handleInputChange}
                        setearValor={setearValor}
                        setearVariosValores={setearVariosValores}
                        classes={classes}
                        nuevoCer={formularioCud ? false : true}
                    />
                    <Grid item xs={12} style={{ textAlign: 'right' }}>
                        <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            type="submit"
                            startIcon={<SaveIcon />}
                            className={classes.button}
                        >
                            GUARDAR
                        </Button>
                    </Grid>
                </Grid>
            </ValidatorForm>
        </Grid>
    )
}
